import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useRemoveFromLibrary = (book_id) => {
	const queryClient = useQueryClient();

	const { accessToken } = useTokenStore();

	const history = useHistory();

	const save = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete(
			`/books/remove-from-library/${book_id}`
		);
		await queryClient.invalidateQueries(["picks"]);
		await queryClient.invalidateQueries(["books"]);
		await queryClient.invalidateQueries(["free_books_quota"]);
		return response;
	};

	return useMutation(save, {
		onSuccess: async ({ data: body }) => {
			toast.success(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useRemoveFromLibrary;
